const $src = document.getElementById('merihari-toc-src')

if ($src) {
  const $headings = $src.querySelectorAll('h2:not(.toc-exclude)')
  const $toc = document.querySelectorAll('.toc')

  if ($headings.length > 1) {
    $toc.forEach((toc, index) => {
      // .tocにクラスを追加
      toc.classList.add('not-prose')

      // 目次のタイトルを作成
      const $tocTitle = document.createElement('h2')
      $tocTitle.classList.add('toc-title', 'not-heading')
      $tocTitle.innerText = '目次'
      toc.appendChild($tocTitle)

      // 目次のリストを作成
      const $tocList = document.createElement('ol')
      $tocList.classList.add('toc-list')
      toc.appendChild($tocList)
      for (let i = 0; i < $headings.length; i++) {
        const $heading = $headings[i]

        // 目次内の見出しを作成
        const $tocItem = document.createElement('li')
        $tocItem.classList.add('toc-item')

        const $tocAnchor = document.createElement('a')
        $tocAnchor.classList.add('toc-a')
        $tocAnchor.href = '#merihari-toc-item-' + i

        const $tocLabel = document.createElement('span')
        $tocLabel.classList.add('toc-label')
        $tocLabel.innerText = $heading.innerText
        $tocAnchor.appendChild($tocLabel)
        $tocItem.appendChild($tocAnchor)

        // 番号を付与
        const $tocNumber = document.createElement('span')
        $tocNumber.classList.add('toc-number')
        $tocNumber.innerText = i + 1 + '.'
        $tocAnchor.insertBefore($tocNumber, $tocAnchor.firstChild)

        $tocList.appendChild($tocItem)

        // 記事内の見出しにアンカーをつける
        if (index === 0) {
          const $anchor = document.createElement('span')
          $anchor.id = 'merihari-toc-item-' + i
          $anchor.classList.add('merihari-toc-anchor')
          $heading.parentNode.insertBefore($anchor, $heading)
        }
      }
    })
  }
}
